<script>

import Number from "./Number.svelte";

import { menu, step, sushiboats, rolls } from "./store.js";

function setQuantity()
{
	if (this.quantity == 0)
	{
		this.quantity++;
	}
	else
	{
		this.quantity = 0;
	}

	$menu = $menu;
}

function update(event)
{
	let delta = event.detail.updated - event.detail.value;

	if ($rolls + delta > $sushiboats * 15)
	{
		event.detail.stop();
	}
}

function updateSushiboats(event)
{
	let delta = event.detail.updated - event.detail.value;

	if ($rolls > event.detail.updated * 15)
	{
		event.detail.stop();
	}
}

</script>

<h2 class="text-xl lg:text-3xl font-semibold uppercase tracking-wide lg:leading-tight">{$menu[$step].title}</h2>
<p class="text-lg text-center">{$menu[$step].description}</p>

<div class="flex flex-col gap-2 w-full max-w-[800px]">

	<div class="flex gap-8 items-center bg-white p-2 px-4 ml-auto mb-2">
		<span class=" mr-auto">Sushi Boats</span>
		<Number min={0} bind:value={$sushiboats} on:update={updateSushiboats} />
		<span class:text-primary="{$rolls == $sushiboats * 15}">Rolls: {$rolls} / {$sushiboats * 15}</span>
	</div>

	{#each $menu[$step].list as item}
		<div class="flex gap-8 items-center bg-white p-2 px-4">
			<span class=" mr-auto">{item.title}</span>

			<div class="flex gap-1">
				<div class="flex flex-col gap-1 items-end">
					<div class="flex gap-4 items-center">
						<Number min={0} bind:value={item.quantity} on:update={update} />
					</div>
				</div>
			</div>

		</div>
	{/each}
</div>